import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { getBonusValues, getReserveBonus, getTargetType } from 'helpers/reserves'

import ReserveTooltip from 'containers/Stronghold/components/ReserveTooltip/ReserveTooltip'
import Reserve from 'components/Reserve/Reserve'
import ReserveProgress from 'components/ReserveProgress/ReserveProgress'
import Timer from 'components/Timer/Timer'

import { MODIFIER_CLAN_LANDING, RESERVE_TOOLTIP_ID } from '../constants'

import styles from '../ClanLandingReserves.scss'

export default class ReserveBlock extends React.Component {
    static propTypes = {
        openStronghold: PropTypes.func.isRequired,
        reserveGroups: PropTypes.object.isRequired,
        reserveList: PropTypes.array.isRequired,
        reserveSettings: PropTypes.object.isRequired,
        reserveType: PropTypes.string.isRequired,
        playHoverSound: PropTypes.func.isRequired,
    }
    getGroup = reserveType => {
        return Object.entries(this.props.reserveGroups).find(
            ([groupName, reserves]) => reserves.includes(reserveType)
        )
    }

    render() {
        const { reserveType, reserveList, reserveSettings, openStronghold } = this.props
        const reserveBonus = getReserveBonus(reserveSettings, reserveType)
        const effectiveReserve = reserveList.find(reserve => reserve.is_effective)
        const endTime = moment(effectiveReserve.effectEnds)
        const level = effectiveReserve.level

        const group = this.getGroup(reserveType)
        const bonusValues = getBonusValues(reserveBonus, level)
        const popoverType = getTargetType(group, bonusValues)

        const tooltipId = `${RESERVE_TOOLTIP_ID}.${reserveType}`
        return (
            <figure className={styles.reserveContainer}>
                <div
                    className={styles.reserveImage}
                    onClick={openStronghold}
                    onMouseEnter={this.props.playHoverSound}
                    data-popover-offset={'{ "bottom": 3 }'}
                    data-popover-type={popoverType}
                    data-tip
                    data-for={tooltipId}
                >
                    <div className={styles.progressContainer}>
                        <ReserveProgress
                            endTime={endTime}
                            totalDuration={reserveBonus.values[level - 1].duration}
                        />
                    </div>
                    <Reserve
                        level={level}
                        type={reserveType}
                        modifier={MODIFIER_CLAN_LANDING}
                        reserves={reserveList}
                    />
                </div>
                <figcaption className={styles.reserveCaption}>
                    <Timer endTime={endTime} hideSeconds />
                </figcaption>
                <ReserveTooltip
                    id={tooltipId}
                    reserveType={reserveType}
                    reserves={{ [level]: reserveList }}
                />
            </figure>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanLandingReserves/components/ReserveBlock.jsx